import type { CurrentGameweekResponse } from './api';

export const FPL_UPDATE_INVALIDATION_ROOTS = ['current-gw', 'fixtures', 'feed-health', 'mini-league-top100', 'overall-top100'] as const;

export interface CurrentGameweekRefreshPolicy {
  refetchIntervalMs: number;
  refetchIntervalInBackground: true;
  window: 'DEADLINE_FAST' | 'QUIET';
}

const FAST_REFRESH_MS = 15_000;
const QUIET_REFRESH_MS = 120_000;
const FAST_BEFORE_DEADLINE_MS = 2 * 60 * 60_000;
const FAST_AFTER_DEADLINE_MS = 4 * 60 * 60_000;

function deadlineMs(value: string | null | undefined): number | null {
  if (!value) return null;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function currentGameweekRefreshPolicy(
  state: CurrentGameweekResponse | undefined,
  nowMs: number = Date.now(),
): CurrentGameweekRefreshPolicy {
  if (!state) {
    return { refetchIntervalMs: FAST_REFRESH_MS, refetchIntervalInBackground: true, window: 'DEADLINE_FAST' };
  }

  const deadlines = [deadlineMs(state.event?.deadline_time), deadlineMs(state.nextEvent?.deadline_time)]
    .filter((value): value is number => value !== null);

  const nearDeadline = deadlines.some((deadline) => {
    const delta = deadline - nowMs;
    return delta <= FAST_BEFORE_DEADLINE_MS && delta >= -FAST_AFTER_DEADLINE_MS;
  });

  return nearDeadline
    ? { refetchIntervalMs: FAST_REFRESH_MS, refetchIntervalInBackground: true, window: 'DEADLINE_FAST' }
    : { refetchIntervalMs: QUIET_REFRESH_MS, refetchIntervalInBackground: true, window: 'QUIET' };
}
